import { render, staticRenderFns } from "./tableRow.vue?vue&type=template&id=beab829e&"
import script from "./tableRow.vue?vue&type=script&lang=js&"
export * from "./tableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/tableRow.vue"
export default component.exports